import { useEffect } from 'react';
import debounce from 'lodash/debounce';
import useSocketContext from '@/providers/Socket/useSocketContext';
import { SocketMessageType } from '@/providers/Socket';
import { rxdbError, rxdbLog } from '../rxdb.tools';
import { getQuestionnaireResponseReplicationIdentifier, prioritizeReplications } from '../rxdb.replication';

const refetchQuestionnaireResponses = debounce(questionnaireId => {
  prioritizeReplications([getQuestionnaireResponseReplicationIdentifier(questionnaireId)]);
}, 1000);

function useResponsesRealtimeSync({ enabled }: { enabled: boolean }): void {
  const { addListener, removeListener, isInitialized: isSocketInitialized } = useSocketContext();

  useEffect(() => {
    if (!isSocketInitialized || !enabled) return () => {};

    const listenerId = addListener({
      fn: data => {
        const { questionnaireId } = (data || {}) as { questionnaireId?: string };

        if (!questionnaireId) {
          rxdbError('Socket received QUESTIONNAIRE_RESPONSES_UPDATED but no questionnaireId', data);
          return;
        }

        rxdbLog('Socket received QUESTIONNAIRE_RESPONSES_UPDATED', questionnaireId);
        refetchQuestionnaireResponses(questionnaireId);
      },
      ignoreSameSessionEvents: true,
      messageType: SocketMessageType.QUESTIONNAIRE_RESPONSES_UPDATED,
    });

    return () => {
      removeListener(listenerId);
    };
  }, [addListener, removeListener, isSocketInitialized, enabled]);
}

export default useResponsesRealtimeSync;
